import {
  PopoverListButton,
  PopoverListButtonProps,
} from '@aibees/shared/components';
import { NotificationActionType as Action } from '@aibees/shared/features/notifications';
import { useDeleteNotificationStatusMutationApi } from '@aibees/shared/features/notifications/api/use-delete-notification-status-mutation-api';
import { useUpdateNotificationStatusMutationApi } from '@aibees/shared/features/notifications/api/use-update-notification-status-mutation-api';
import { useNotificationStore } from '@aibees/shared/features/notifications/store';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { NOTIFICATION_ACTION_MENU_ITEMS } from './config';
import type { NotificationActionPopupProps as Props } from './types';

const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'left',
} as const;

export const NotificationActionPopup = memo(({ className, item }: Props) => {
  const apiDeliver = useUpdateNotificationStatusMutationApi(
    item.id,
    Action.DELIVER
  );

  const apiDelete = useDeleteNotificationStatusMutationApi(item.id);

  const markNotificationAsSeen =
    useNotificationStore.useMarkNotificationAsSeen();

  const handleSelect: PopoverListButtonProps['onSelect'] = (e) => {
    markNotificationAsSeen(item.id);

    if (e.key === Action.DELIVER) {
      apiDeliver.mutateAsync(null);
    } else {
      apiDelete.mutateAsync(null);
    }
  };

  return (
    <PopoverListButton
      className={classnames('NotificationActionPopup', className)}
      icon="more-horizontal"
      variant="soft"
      size="xsmall"
      buttonProps={{ color: 'default' }}
      items={NOTIFICATION_ACTION_MENU_ITEMS(item?.status)}
      itemDivider={true}
      onSelect={handleSelect}
      anchorOrigin={ANCHOR_ORIGIN}
    />
  );
});

NotificationActionPopup.displayName = 'NotificationActionPopup';
